import React from "react";
import TopProducts from "./TopProducts";
import CategoriesSct from "./CategoriesSct";
import BannersSct from "./BannersSct";
import SmartGadgetsSct from "./SmartGadgetsSct";
import BottomBannerSct from "./BottomBannerSct";
import AmazingProducts from "./AmazingProducts";
import PopularProducts from "./PopularProducts";
import {
  useGetPriorityCategoryQuery,
  useGetProductsQuery,
  useGetSliderQuery,
} from "../../../Store/Slices/rtk";
import {
  AmazingProductsSk,
  BannersSctSk,
  CategoriesSctSk,
  PopularProductsSk,
  SmartGadgetsSctSk,
  TopProductsSk,
} from "./HomeSkeletons";
import { Stack } from "@mui/material";
import LightRays from "../../../Components/LightRays";

export default function Home() {
  // Popular Products
  const popularProducts = useGetProductsQuery(
    "?page=1&sort_type=best_seller&no_of_docs_each_page=10",
  );
  // Popular Products
  const amazingProducts = useGetProductsQuery(
    "?page=1&by_tag=amazing&no_of_docs_each_page=10",
  );
  // smart gadget Products
  const smartGadgetProducts = useGetProductsQuery(
    "?page=1&by_tag=smart-gadget&no_of_docs_each_page=10",
  );
  // Cats
  const cats = useGetPriorityCategoryQuery();
  // Banners
  const sliders = useGetSliderQuery("home");
  return (
    <>
      <Stack sx={{ display: { xs: "none", lg: "flex" } }}>
        <LightRays />
      </Stack>
      <Stack sx={{ gap: "150px" }}>
        {/* Grid template Products */}
        {sliders?.isLoading || sliders?.status != "fulfilled" ? (
          <TopProductsSk />
        ) : (
          <TopProducts banners={sliders?.data?.data?.slides} />
        )}

        {/* Categories Sct */}
        {cats?.isLoading || cats?.status != "fulfilled" ? (
          <CategoriesSctSk />
        ) : (
          <CategoriesSct categories={cats?.data?.data} />
        )}

        {/* Popular Products */}
        {popularProducts?.isLoading ||
        popularProducts?.status != "fulfilled" ? (
          <PopularProductsSk />
        ) : (
          <PopularProducts products={popularProducts?.data?.data} />
        )}

        {/* Banners */}
        {sliders?.isLoading || sliders?.status != "fulfilled" ? (
          <BannersSctSk />
        ) : (
          <BannersSct banners={sliders?.data?.data?.slides} />
        )}

        {/* Smart Gadgets */}
        {smartGadgetProducts?.isLoading ||
        smartGadgetProducts?.status != "fulfilled" ? (
          <SmartGadgetsSctSk />
        ) : (
          <SmartGadgetsSct products={smartGadgetProducts?.data?.data} />
        )}

        {/* Bottom Banner */}
        {sliders?.isLoading || sliders?.status != "fulfilled" ? null : (
          <BottomBannerSct banners={sliders?.data?.data?.slides} />
        )}

        {/* Amazing Products */}
        {amazingProducts?.isLoading ||
        amazingProducts?.status != "fulfilled" ? (
          <AmazingProductsSk />
        ) : (
          <AmazingProducts products={amazingProducts?.data?.data} />
        )}
      </Stack>
    </>
  );
}
